import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class Tabs extends MainClass {
	private tabs: HTMLElement[];
	private tabType: string;
	private pageContentWrapper: HTMLElement;
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.tabs = Array.from( this.selector.querySelectorAll( '.raise-tabs .raise-tab-item' ) ) as HTMLElement[];
		this.tabType = this.selector.getAttribute( 'data-tab-type' ) || 'anchor';
		this.pageContentWrapper = this.selector.closest( '.raise-main' ) as HTMLElement;
		this.selector && this.init();
	}

	handleActiveTab( el: HTMLElement ) {
		const tabLine = this.selector.querySelector( '.raise-tab-line' ) as HTMLElement;
		this.tabs.forEach( ( item: HTMLElement ) => {
			item.classList.remove( 'active' );
		} );

		tabLine.style.width = `${ el.offsetWidth }px`;
		tabLine.style.left = `${ el.offsetLeft }px`;

		el.classList.add( 'active' );

		if ( this.tabType === 'change-tab' ) {
			const contentTabs = Array.from(
				this.pageContentWrapper.querySelectorAll( 'div[data-content-type="raise-content-tab"]' ),
			) as HTMLElement[];
			contentTabs.forEach( ( item: HTMLElement ) => {
				if ( item.classList.contains( 'active' ) ) {
					item.classList.remove( 'active' );
				}
				if ( item.getAttribute( 'id' ) === el.getAttribute( 'id' ) ) {
					item.classList.add( 'active' );
				}
			} );
		}
	}

	init() {
		const pagination = Array.from(this.pageContentWrapper.querySelectorAll( '.raise-cta-pagination' )) as HTMLElement[];
		if ( this.tabs.length ) {
			this.tabs.forEach( tab => {
				tab.addEventListener( 'click', () => this.handleActiveTab( tab ) );
				setTimeout( () => {
					tab.classList.contains( 'active' ) && this.handleActiveTab( tab );
				}, 200 );
			} );
		}
		if (pagination?.length) {
			pagination.forEach(item => {
				item.addEventListener( 'click', ( e: Event ) => {
					e.preventDefault();
						const tabTarget = this.selector.querySelector(
							`.raise-tabs .raise-tab-item#${ item.getAttribute( 'id' ) }`,
						) as HTMLElement;
						if ( tabTarget ) {
							this.handleActiveTab( tabTarget );
						}
				} );
			})
			
		}
	}
}

export default Tabs;
